export default __webpack_public_path__ + "assets/audio/Door.e9804a45.m4a";